<app-review-section
  *ngIf="form"
  #reviewSection
  [applicationId]="applicationId"
  [sectionId]="sectionIdentifier.Document_ContactPerson"
  [title]="'documents.contact-person.section-header' | translate | uppercase"
  [tooltip]="'tooltips.documents-submission.document-header-info' | translate"
  [showTooltip]="environmentService.showDocumentHeaderHintIcon && currentInstallationFlow === installationFlowType.MainsConnection"
  [isDetailsView]="isDetailsView"
  [formGroup]="form"
  [checkIfIsEditable]="checkIfIsEditable"
  [forceAllowAddMessages]="forceAllowAddMessages"
  [areButtonsVisible]="false"
  [showButtonsPredicate]="false"
  (onChanges)="onReviewSectionChange($event)">
  <!-- NAME -->
  <div class="ui-g-6 ui-xl-6 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <label class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-4 ui-xs-4 field-label text-right-align required" for="contact-person-name">
      {{ 'documents.contact-person.name' | translate }}
    </label>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <input class="doc-submit-inputs" id="contact-person-name" pInputText type="text" formControlName="name" />
    </div>
  </div>

  <!-- PHONE NUMBER -->
  <div class="ui-g-6 ui-xl-6 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 form-column margin-align">
    <label class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-4 ui-sm-4 ui-xs-4 field-label text-right-align required" for="contact-person-phone">
      {{ 'documents.contact-person.telephone-number' | translate }}
    </label>
    <div class="ui-g-4 ui-xl-4 ui-lg-4 ui-md-12 ui-sm-12 ui-xs-12">
      <input class="doc-submit-inputs" id="contact-person-phone" pInputText appAllowOnlyDigits maxDigits="30" formControlName="phone" />
    </div>
  </div>
</app-review-section>
